

import React from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import SearchForm from '../containers/SearchFormContainer';
import Button from '../../../common/button/Button';

const removeBlockScroll = () => {
    document.body.style.overflow = 'auto';
};

const SearchBox = (props) => (
    <div id="searchBoxModal">
        <ReactModal
            isOpen={props.modalSearchBoxIsOpen}
            contentLabel="Search Modal"
            className="searchBox"
            overlayClassName="overlay_searchModal"
        >
            <Button
                className="close"
                title="Fechar janela"
                onClick={() => {
                    removeBlockScroll();

                    props.setModalSearchBoxState(false);
                }}
            >
                &nbsp;
            </Button>
            <SearchForm isModal="true" />
        </ReactModal>
    </div>
);

SearchBox.propTypes = exact({
    modalSearchBoxIsOpen: PropTypes.bool,
    setModalSearchBoxState: PropTypes.func,
});

export default SearchBox;
